import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/ConfiguratorHome.css';

/**
 * ConfiguratorHome - Page de sélection du type de système
 * Adapté pour le site bt-regulation.fr
 */
function ConfiguratorHome() {
  const navigate = useNavigate();

  const handleSystemSelect = (system) => {
    navigate(`/configurateur?system=${system}`);
  };

  const handleReturnHome = () => {
    navigate('/');
  };

  return (
    <div className="bt-configurator-home">
      <header className="bt-header">
        <div className="bt-header-content">
          <div className="bt-logo-section">
            <img
              src={`${process.env.PUBLIC_URL}/images/Logo1.png`}
              alt="BT Régulation"
              className="bt-logo"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = `${process.env.PUBLIC_URL}/images/Logo1.png`;
              }}
            />
            <div className="bt-logo-text">
              <h1>Configurateur</h1>
              <p>Choisissez votre Énergie</p>
            </div>
          </div>

          <button
            onClick={handleReturnHome}
            className="bt-btn bt-btn-outline"
          >
            ← Retour à l'accueil
          </button>
        </div>
      </header>

      <main className="bt-main">
        <div className="bt-systems-container">

          {/* Système Chauffage */}
          <button
            className="bt-system-card bt-system-active"
            onClick={() => handleSystemSelect('chauffage')}
            aria-label="Configurer un système de chauffage et cascade"
          >
            <div className="bt-system-content">
              <div className="bt-system-icon">
                <img src={`${process.env.PUBLIC_URL}/images/SYS-CHF.jpg`} alt="Système Chauffage" />
              </div>
              <h2 className="bt-system-title">Système Chaudière et Cascade</h2>
              <span className="bt-system-status bt-status-active">✓ Version v1.22</span>
              <p className="bt-system-description">
                Configurez un système de chaudière classique ou une cascade de chaudières
              </p>
            </div>
          </button>

          {/* Système Vapeur */}
          <button
            className="bt-system-card bt-system-active"
            onClick={() => handleSystemSelect('vapeur')}
            aria-label="Configurer un système vapeur et cascade"
          >
            <div className="bt-system-content">
              <div className="bt-system-icon">
                <img src={`${process.env.PUBLIC_URL}/images/SYS-VAP.jpg`} alt="Système Vapeur" />
              </div>
              <h2 className="bt-system-title">Réseau de Chaleur</h2>
              <span className="bt-system-status bt-status-active">✓ Version v1.22</span>
              <p className="bt-system-description">
                Configurez un réseau de chaleur simple ou en cascade
              </p>
            </div>
          </button>

          {/* Système Hybride - Bientôt disponible */}
          <button
            className="bt-system-card bt-system-disabled"
            disabled
            title="Système Hybride - Bientôt disponible"
          >
            <div className="bt-system-content">
              <div className="bt-system-icon">
                <img src={`${process.env.PUBLIC_URL}/images/SYS-HYB.jpg`} alt="Système Hybride" />
              </div>
              <h2 className="bt-system-title">Système Hybride</h2>
              <span className="bt-system-status bt-status-disabled">⏳ Bientôt Disponible</span>
              <p className="bt-system-description">
                Configuration pour systèmes hybrides
              </p>
            </div>
          </button>

        </div>
      </main>

      <footer className="bt-footer">
        <p>Configurateur BT-Régulation © 2025 VIGILIA</p>
      </footer>
    </div>
  );
}

export default ConfiguratorHome;
